import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { CalendarDayView, CalendarHourlyView } from "@miplatform/assets";
import { ENTITY_TYPES } from "@miplatform/constants";
import { CalendarType } from "@miplatform/types";
import { getDate } from "@miplatform/utils";
import { Grid } from "@mui/material";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { ICalendarSetData } from "../../ConfigCalendarSetList.types";
import { CalendarDisplayTypeCard } from "./CalendarDisplayTypeCard";

export const CalendarDisplayTypeTabView: FC<
  CalendarDisplayTypeTabViewProps
> = ({ form, extraTabProps: { isDisabled, isReadOnly, eventType } = {} }) => {
  const { setValue, watch, clearErrors } = form;
  const calendarConfigs = watch("calendarConfigs");
  const displayTypes =
    eventType === ENTITY_TYPES.WORK_ORDER
      ? workOrderDisplayTypes
      : orderDisplayTypes;

  return (
    <ConfigAccordionHeader title="Calendar Display Type">
      <Grid container spacing={2}>
        {displayTypes.map((type) => (
          <Grid key={type.value} size={{ xs: 12, sm: 6 }}>
            <CalendarDisplayTypeCard
              isDisabled={isDisabled || isReadOnly}
              {...type}
              isSelected={calendarConfigs[0]?.calendarType === type.value}
              onClick={() => {
                if (calendarConfigs[0]?.calendarType === type.value) {
                  return;
                }

                setValue(
                  "calendarConfigs.0.calendarType",
                  type.value as CalendarType,
                  {
                    shouldDirty: true,
                  }
                );

                if (type.value === CalendarType.Kanban) {
                  setValue("workCapacities", {});
                  setValue("assignableUsers", []);
                  setValue("dayStartTime", getDate().hours(9).minutes(0));
                  setValue("dayEndTime", getDate().hours(17).minutes(0));
                  clearErrors("dayStartTime");
                  clearErrors("dayEndTime");
                }
              }}
            />
          </Grid>
        ))}
      </Grid>
    </ConfigAccordionHeader>
  );
};

interface CalendarDisplayTypeTabViewProps {
  form: UseFormReturn<ICalendarSetData>;
  extraTabProps?: {
    isDisabled?: boolean;
    isReadOnly?: boolean;
    eventType?: string;
  };
}

const orderDisplayTypes = [
  {
    label: "Day View",
    value: CalendarType.Kanban,
    imgSrc: CalendarDayView,
    description:
      "Presents a single day visualization of work on a calendar allowing users to manage work on that day.",
  },
  {
    label: "Hourly View",
    value: CalendarType.Scheduler,
    imgSrc: CalendarHourlyView,
    description:
      "Shows an hourly based calendar to manage work by resource for a given day.",
  },
];

const workOrderDisplayTypes = [
  {
    label: "Priority Scheduler View",
    value: CalendarType.PriorityScheduler,
    imgSrc: CalendarHourlyView,
    description:
      "Presents a single day visualization of work orders on a calendar allowing users to manage work on that day.",
  },
];
